
import SpinRequestPayload from "slotworks/model/gameplay/requests/spin-request-payload";
import CommsManager from "slotworks/server/comms-manager";
import Contract from "slotworks/utils/contract";

export function LoadSpinCommand(): Contract<void> {
    const payload = new SpinRequestPayload();

    return CommsManager.request(payload);
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/commands/comms/load-spin-command.ts